import { jsx as _jsx } from "react/jsx-runtime";
import { formatMoney, parseMoney } from "@commerce-os/utils";
import { useState } from "react";
import { cn } from "../lib/cn.js";
import { Input } from "./input.js";
/** An amount in paisa, shown in the user's language and digits (`৳1,250.50`). Never a float. */
export function MoneyText({ paisa, format, className, }) {
    return _jsx("span", { className: cn("tabular-nums", className), children: formatMoney(paisa, format) });
}
/**
 * Typed money → paisa (`bigint`), either digit set. `onChange` gets `null` while the text is not an amount; the
 * field is then marked invalid. On blur a valid amount is re-shown formatted.
 */
export function MoneyInput({ value, onChange, format, className, ...props }) {
    const [text, setText] = useState(() => (value === null ? "" : formatMoney(value, format).replace("৳", "")));
    const invalid = text.trim() !== "" && parseMoney(text) === null;
    return (_jsx(Input, { inputMode: "decimal", value: text, "aria-invalid": invalid ? true : props["aria-invalid"], className: cn("text-right tabular-nums", className), onChange: (event) => {
            setText(event.target.value);
            onChange(event.target.value.trim() === "" ? null : parseMoney(event.target.value));
        }, onBlur: (event) => {
            const paisa = parseMoney(text);
            if (paisa !== null)
                setText(formatMoney(paisa, format).replace("৳", ""));
            props.onBlur?.(event);
        }, ...props }));
}
//# sourceMappingURL=money.js.map